var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnswer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_55743",
    "data-name": "\\u7EC4 55743",
    transform: "translate(-1628.374 -555.848)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_8624",
    "data-name": "\\u8DEF\\u5F84 8624",
    d: "M44.326,69.632H36.874A11.027,11.027,0,0,0,25.6,80.381v.2A11.008,11.008,0,0,0,36.195,91.311v2.815a1.482,1.482,0,0,0,.868,1.34,1.637,1.637,0,0,0,1.642-.12l5.7-4A11.037,11.037,0,0,0,55.6,80.592v-.2A11.04,11.04,0,0,0,44.326,69.632Z",
    transform: "translate(1602.774 486.216)",
    fill: "#226fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_55743-2",
    "data-name": "\\u7EC4 55743",
    transform: "translate(1635.4 564.92)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5BA2\\u670D",
    transform: "translate(-0.026)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_8621",
    "data-name": "\\u8DEF\\u5F84 8621",
    d: "M282.783,389.329m-1.695,0a1.7,1.7,0,1,0,1.695-1.745A1.721,1.721,0,0,0,281.088,389.329Z",
    transform: "translate(-281.088 -387.584)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_8622",
    "data-name": "\\u8DEF\\u5F84 8622",
    d: "M462.495,389.329m-1.695,0a1.7,1.7,0,1,0,1.695-1.745A1.721,1.721,0,0,0,460.8,389.329Z",
    transform: "translate(-454.641 -387.584)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_8623",
    "data-name": "\\u8DEF\\u5F84 8623",
    d: "M642.207,389.329m-1.695,0a1.7,1.7,0,1,0,1.695-1.745A1.721,1.721,0,0,0,640.512,389.329Z",
    transform: "translate(-628.194 -387.584)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnswer);
export default __webpack_public_path__ + "static/media/answer.a3985e037c35c43e570d727c5a85093d.svg";
export { ForwardRef as ReactComponent };